var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "file-full-image",
      class: { show: _vm.show },
      style: { "z-index": new Date().valueOf() },
      on: {
        click: function ($event) {
          $event.stopPropagation()
          $event.preventDefault()
        },
      },
    },
    [
      _c(
        "el-carousel",
        {
          ref: "el-carousel",
          staticClass: "image-main-wrapper",
          attrs: { autoplay: false },
        },
        _vm._l(_vm.files, function (file, index) {
          return _c(
            "el-carousel-item",
            {
              key: _vm.imageName(file),
              attrs: {
                name: _vm.imageName(file),
                "initial-index": _vm.initialIndex,
              },
            },
            [
              _c("wl-image", {
                staticClass: "position-center",
                attrs: { src: file.url, fit: _vm.fit, title: file },
              }),
            ],
            1
          )
        }),
        1
      ),
      _c("div", { staticClass: "file-full-image-background position-center" }),
      _c("div", {
        staticClass: "close el-icon-circle-close",
        on: {
          click: function ($event) {
            $event.stopPropagation()
            $event.preventDefault()
            return _vm.$emit("update:show", false)
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }